import {ConstantDefinition} from "../constants/ConstantDefinition";
import {Chip} from "@mui/material";

export default function ConstantChip(props: {definition: ConstantDefinition<any>}) {
   return <Chip size='small' label={props.definition.title} sx={{color: 'white', bgcolor: props.definition.color}} />
}
